import { Injectable } from '@angular/core';
import { enduserInterface } from '../interfaces/enduser';
import { customerInterface } from '../interfaces/customer';

@Injectable()
export class mspGlobal {
	labels: any = {};
	permissions: any = {
		geral_hide_search: false,
		cmdb_allowed_delete: false,
		cmdb_bind_solution_area: false,
		stock_visualizar: false,
	};
	userData: enduserInterface;
	availableCustomers: customerInterface[];
}
